import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { BottomSheetBody } from "@opensea/ui-kit";
import { useMemo } from "react";
import { useTranslations } from "use-intl";
import { TransactionFullScreen } from "../../../../../components/TransactionFullScreen";
import { useFlowFinalTransactionStatus } from "../../../../hooks/useFlowFinalTransactionStatus";
import { CancelOrderFlowStatus_orderFragment } from "./CancelOrderFlowStatus.fragment";
export const CancelOrderStatus = t0 => {
  const $ = _c(37);
  const {
    orders,
    status
  } = t0;
  const t = useTranslations("wallet.CancelOrderFlowStatus");
  const order = readFragment(CancelOrderFlowStatus_orderFragment, orders[0]);
  let t1;
  bb0: {
    if (order.side === "LISTING") {
      let t2;
      if ($[0] !== orders) {
        t2 = orders.map(_temp);
        $[0] = orders;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    if (order.type === "CRITERIA_COLLECTION" || order.type === "CRITERIA_TRAIT") {
      let t2;
      if ($[2] !== orders) {
        t2 = orders.map(_temp2);
        $[2] = orders;
        $[3] = t2;
      } else {
        t2 = $[3];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[4] !== orders) {
      t2 = orders.map(_temp3);
      $[4] = orders;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = t2;
  }
  const imageUrls = t1;
  let t2;
  bb1: {
    if (order.side === "LISTING") {
      let t3;
      if ($[6] !== orders.length || $[7] !== t) {
        t3 = t("success.listingCanceled", {
          count: orders.length
        });
        $[6] = orders.length;
        $[7] = t;
        $[8] = t3;
      } else {
        t3 = $[8];
      }
      t2 = t3;
      break bb1;
    }
    if (order.type === "CRITERIA_COLLECTION") {
      let t3;
      if ($[9] !== orders.length || $[10] !== t) {
        t3 = t("success.collectionOfferCanceled", {
          count: orders.length
        });
        $[9] = orders.length;
        $[10] = t;
        $[11] = t3;
      } else {
        t3 = $[11];
      }
      t2 = t3;
      break bb1;
    }
    if (order.type === "CRITERIA_TRAIT") {
      let t3;
      if ($[12] !== orders.length || $[13] !== t) {
        t3 = t("success.traitOfferCanceled", {
          count: orders.length
        });
        $[12] = orders.length;
        $[13] = t;
        $[14] = t3;
      } else {
        t3 = $[14];
      }
      t2 = t3;
      break bb1;
    }
    let t3;
    if ($[15] !== orders.length || $[16] !== t) {
      t3 = t("success.offerCanceled", {
        count: orders.length
      });
      $[15] = orders.length;
      $[16] = t;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    t2 = t3;
  }
  const title = t2;
  if (status === "pending") {
    let t3;
    if ($[18] !== t) {
      t3 = t("pending.description");
      $[18] = t;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    let t4;
    if ($[20] !== t) {
      t4 = t("pending.title");
      $[20] = t;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    let t5;
    if ($[22] !== imageUrls || $[23] !== t3 || $[24] !== t4) {
      t5 = <BottomSheetBody><TransactionFullScreen body={t3} images={imageUrls} loading={true} title={t4} /></BottomSheetBody>;
      $[22] = imageUrls;
      $[23] = t3;
      $[24] = t4;
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    return t5;
  }
  if (status === "error") {
    let t3;
    if ($[26] !== t) {
      t3 = t("error.description");
      $[26] = t;
      $[27] = t3;
    } else {
      t3 = $[27];
    }
    let t4;
    if ($[28] !== t) {
      t4 = t("error.title");
      $[28] = t;
      $[29] = t4;
    } else {
      t4 = $[29];
    }
    let t5;
    if ($[30] !== imageUrls || $[31] !== t3 || $[32] !== t4) {
      t5 = <BottomSheetBody><TransactionFullScreen body={t3} images={imageUrls} monochrome={true} title={t4} /></BottomSheetBody>;
      $[30] = imageUrls;
      $[31] = t3;
      $[32] = t4;
      $[33] = t5;
    } else {
      t5 = $[33];
    }
    return t5;
  }
  let t3;
  if ($[34] !== imageUrls || $[35] !== title) {
    t3 = <BottomSheetBody><TransactionFullScreen images={imageUrls} monochrome={true} title={title} /></BottomSheetBody>;
    $[34] = imageUrls;
    $[35] = title;
    $[36] = t3;
  } else {
    t3 = $[36];
  }
  return t3;
};
export function CancelOrderFlowStatus(t0) {
  const $ = _c(3);
  const {
    orders
  } = t0;
  const status = useFlowFinalTransactionStatus();
  let t1;
  if ($[0] !== orders || $[1] !== status) {
    t1 = <CancelOrderStatus orders={orders} status={status} />;
    $[0] = orders;
    $[1] = status;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(fragment) {
  return readFragment(CancelOrderFlowStatus_orderFragment, fragment).item?.imageUrl;
}
function _temp2(fragment_0) {
  return readFragment(CancelOrderFlowStatus_orderFragment, fragment_0).collection.imageUrl;
}
function _temp3(fragment_1) {
  return readFragment(CancelOrderFlowStatus_orderFragment, fragment_1).item?.imageUrl;
}